import script from "./EmailViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailViewer.vue?vue&type=script&setup=true&lang=js"

import "./EmailViewer.vue?vue&type=style&index=0&id=c03d14b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c03d14b8"]])

export default __exports__